<template>
    <div class="Stepper">
        <div
            class="Stepper-line"
            :style="{ height: getHeight }"
        />
        <div
            :style="{ height: getSubHeight }"
            class="Stepper-subline"
        />
        <template
            v-for="(step, index) in steps"
            :key="`flag_${index}`"
        >
            <step
                :state="getState(index)"
                :step="index + 1"
                :title="step.title"
            />
            <collapser
                ref="referenceCollapser"
                :visible="index === currentStep"
                :component="step.component"
                :props="step.props"
                :text="step.description"
                v-bind="$attrs"
                class="Stepper-collapser"
                v-on="forwardedEvents"
            />
        </template>
    </div>
</template>

<script setup>
import Collapser from '@/StoreWeb/components/common/stepper/Collapser.vue'
import Step from '@/StoreWeb/components/common/stepper/Step.vue'
import { forwardEvents } from '@/StoreWeb/js/forward-events'
import { computed, ref } from 'vue'

const emit = defineEmits([])

const props = defineProps({
    currentStep: {
        type: Number,
        required: true
    },
    steps: {
        type: Array,
        required: true
    }
})

const referenceCollapser = ref(null)
const forwardedEvents = forwardEvents(emit)

const getHeight = computed(() => {
    // Add flag + gap heights
    const height = (28 * props.currentStep) + (28 * props.currentStep)

    return `${height}px`
})

const getSubHeight = computed(() => {
    return props.currentStep === props.steps.length - 1 ? getHeight.value : '100%'
})

function getState (index) {
    if (props.currentStep > index) {
        return 'completed'
    }

    if (props.currentStep < index) {
        return 'todo'
    }

    return props.steps[props.currentStep]?.state || 'current'
}
</script>

<style lang="scss" scoped>
@import 'globalScss';

.Stepper {
    display: flex;
    flex-direction: column;
    gap: $s7;
    position: relative;

    &-line,
    &-subline {
        position: absolute;
        top: 0;
        left: 13px;
        width: 2px;
        background-color: $color-brandPrimary;
        transition: height .3s ease-in-out;
    }

    &-subline {
        opacity: .4;
    }

    &-collapser {
        margin-top: $ns7;
    }
}
</style>
